import { createContext } from 'react';

export const InboxContext = createContext(null);